import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "TaxZoneListPage" */
	'pages/Invoice/TaxZone/TaxZoneListPage'));

export default [{ component, exact: true, path: '/tax_zones' }];